export default {
    parametros: {},
    linguagem: 'pt',
    licitacao: {},
    tema:{
        primary:'#0067A5',
        secondary: '#104D75'
    },
    file: {
        api: '/licitacao/hal/public/arquivos',
        maxSize: '30Mb'
    },
}
